import { Component, VERSION } from '@angular/core';
import { environment } from './../environments/environment';
import { SessionAction } from './app-states/modules/session/session.action';
import { AuthenticationService } from './core/security/services/authentication.service';
import { Router, NavigationEnd } from '@angular/router';
import { GaActivitiesService } from './core/google-analytics/ga-activities.service';


@Component({
  selector: 'mc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private sessionAction: SessionAction,
    private authService: AuthenticationService,
    private googleAnalytics: GaActivitiesService,
    private router: Router) {

    this.googleAnalytics.create();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.googleAnalytics.pageView(event.urlAfterRedirects);
      }
    });

    authService.getSessionChanges().subscribe((identitySession) => {
      if (identitySession && identitySession.user) {
        this.googleAnalytics.user(identitySession.user);
      }
      this.sessionAction.userAuthenticationUpdate(identitySession);
    });

  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app.component.ts